// extracted by mini-css-extract-plugin
export default {"imageDetailsContainer":"style_imageDetailsContainer__ymw6H","imageDetailsBody":"style_imageDetailsBody__fLolD","metadataTitle":"style_metadataTitle__tg8Qu"};